<div class="container p-12">
  @if (fetchingTenant) {
    <div class="flex justify-center">
      <div class="loading loading-spinner loading-lg"></div>
    </div>
  } @else if (tenantFetchError || !tenant) {
    <div class="mt-4 text-center text-error">
      <p>{{ tenantFetchError ? tenantFetchError : 'Tenant not found' }}</p>
    </div>
  } @else if (tenant) {
    <app-tenant-info-form [tenant]="tenant"></app-tenant-info-form>

    <hr class="my-8 border-base-content/20" />

    <div>
      <h2 class="text-lg font-semibold">Admin Settings</h2>
      <div class="mt-4">
        <div class="flex flex-wrap justify-between">
          <div class="min-w-[12rem] basis-1/3 pr-8">
            <label class="form-control">
              <div class="label">
                <span class="label-text">Quickbooks/Avatax Company Code</span>
              </div>
              <input
                type="text"
                [(ngModel)]="avataxCustomerCode"
                class="input input-bordered w-full"
              />
            </label>

            <div class="label mt-4 justify-start">
              <input
                type="checkbox"
                [(ngModel)]="autopayEnabled"
                class="checkbox"
              />
              <span class="label-text ml-2">Auto Pay Enabled</span>
            </div>

            <div class="label mt-4 justify-start">
              <input
                type="checkbox"
                [(ngModel)]="ignoreApiInvoices"
                class="checkbox"
              />
              <span class="label-text ml-2">Ignore API Invoices</span>
            </div>
          </div>

          <div class="min-w-[12rem] basis-2/3">
            <label class="form-control">
              <div class="label">
                <span class="label-text">Notes</span>
              </div>
              <textarea
                class="textarea textarea-bordered w-full"
                rows="4"
                [(ngModel)]="notes"
              ></textarea>
            </label>
          </div>
        </div>
      </div>

      <div class="mt-12">
        <div class="flex justify-center space-x-8">
          <button
            class="btn btn-primary"
            [disabled]="updating"
            (click)="submitAdminSettings()"
          >
            Submit
          </button>
          <button class="btn btn-secondary" (click)="back()">Back</button>
        </div>

        @if (updateError) {
          <div class="mt-4 text-center text-error">
            <p>{{ updateError }}</p>
          </div>
        } @else if (updating) {
          <div class="mt-4 flex justify-center">
            <div class="loading loading-spinner loading-lg"></div>
          </div>
        } @else if (updateSuccess) {
          <div class="mt-8 text-center text-success">
            <p>Successfully updated tenant</p>
          </div>
        }

        @if (qboError) {
          <div class="mt-4 text-center text-error">
            <p>{{ qboError }}</p>
          </div>
        }
      </div>
    </div>
  }
</div>
